import { useMutation } from '@hooks/reactQuery';

import { clearActiveAlarm } from '@api/clearAlarm';

import { IOnSuccess } from '@interfaces/common/handlers';

import { EXPORT_ALARM_HISTORY } from '@constants/queryKeys';

export const useMutateClearAlarm = ({ onSuccess }: Partial<IOnSuccess>) => {
	const {
		mutate: clearAlarm,
		isLoading: isLoadingClearAlarm,
	} = useMutation<{ id: string }>({
		mutationKey: [EXPORT_ALARM_HISTORY],
		mutationFn: clearActiveAlarm,
		onSuccess: () => {
			if (onSuccess) onSuccess();
		},
	});

	return {
		clearAlarm,
		isLoadingClearAlarm,
	};
};
